// react
import React from 'react';
import ReactDOM from 'react-dom';
// antd
import { LocaleProvider } from 'antd-mobile';
// store
import { Provider } from 'mobx-react';
import store from './store';
import Router from './router';
import * as dd from 'dingtalk-jsapi';
// sw
import * as serviceWorker from './serviceWorker';
import FastClick from 'fastclick';
// 设置登录注册埋点
import { setUtm } from './utils/utm';
import { utils, ajax } from '@clouderwork/ywk';
// import "@src/assets/js/"
// css reset
import '@src/assets/css/reset.less';
import '@src/assets/css/index.less';
import './scalable';
import moment from 'moment';
import '@clouderwork/jsbridge';

// 里面的字符可以根据自己的需要进行调整
moment.locale('zh-cn', {
  months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
  monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
  weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
  weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
  weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
  longDateFormat: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    L: 'YYYY-MM-DD',
    LL: 'YYYY年MM月DD日',
    LLL: 'YYYY年MM月DD日Ah点mm分',
    LLLL: 'YYYY年MM月DD日ddddAh点mm分',
    l: 'YYYY-M-D',
    ll: 'YYYY年M月D日',
    lll: 'YYYY年M月D日 HH:mm',
    llll: 'YYYY年M月D日dddd HH:mm'
  },
  meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
  meridiemHour: function (hour: number, meridiem: string) {
    if (hour === 12) {
      hour = 0;
    }
    if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
      return hour;
    } else if (meridiem === '下午' || meridiem === '晚上') {
      return hour + 12;
    } else {
      // '中午'
      return hour >= 11 ? hour : hour + 12;
    }
  },
  meridiem: function (hour, minute) {
    const hm = hour * 100 + minute;
    if (hm < 600) {
      return '凌晨';
    } else if (hm < 900) {
      return '早上';
    } else if (hm < 1130) {
      return '上午';
    } else if (hm < 1230) {
      return '中午';
    } else if (hm < 1800) {
      return '下午';
    } else {
      return '晚上';
    }
  },
  calendar: {
    sameDay: '[今天] A LT',
    nextDay: '[明天]LT',
    nextWeek: '[下]ddddLT',
    lastDay: '[昨天]LT',
    lastWeek: '[上]ddddLT',
    sameElse: 'L'
  },
  dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
  relativeTime: {
    future: '%s内',
    past: '%s前',
    s: '几秒',
    ss: '%d秒',
    m: '1分钟',
    mm: '%d分钟',
    h: '1小时',
    hh: '%d小时',
    d: '1天',
    dd: '%d天',
    M: '1个月',
    MM: '%d个月',
    y: '1年',
    yy: '%d年'
  },
  week: {
    // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
    dow: 1, // Monday is the first day of the week.
    doy: 4 // The week that contains Jan 4th is the first week of the year.
  }
});

console.log('xxxxxx', document.getElementsByTagName('meta')['viewport']);
// 以375设计稿适配
window.Adapter.setAdapterDesign({
  width: 375
});
// @ts-ignore
// console.log('hhhhhhhh', `${ENT_DOMAIN}`);
// router

// 钉钉环境实例化
if (process.env.REACT_APP_PLATFORM === 'monitor' && dd.env.platform !== 'notInDingTalk') {
  const getDDConfig = async () => {
    const corpId = utils.getQueryString('corpId') || sessionStorage.getItem('corpId') || '';
    if (corpId) {
      sessionStorage.setItem('corpId', corpId);
    }
    const url = window.location.href.split('#')[0];
    const res = await ajax.post('/monitor/api/dingtalk/jsconfig_sign', {
      url,
      corpid: corpId
    });
    const { error_code, data, msg } = res;
    if (error_code === 0) {
      dd.config({
        agentId: data.agentId, // 必填，微应用ID
        corpId: data.corpId, // 必填，企业ID
        timeStamp: data.timeStamp, // 必填，生成签名的时间戳
        nonceStr: data.nonceStr, // 必填，自定义固定字符串。
        signature: data.signature, // 必填，签名
        type: 0, // 选填。0表示微应用的jsapi,1表示服务窗的jsapi；不填默认为0。该参数从dingtalk.js的0.8.3版本开始支持
        jsApiList: [
          'runtime.info',
          'device.notification.modal',
          'device.notification.confirm',
          'device.notification.alert',
          'device.notification.prompt',
          'biz.ding.post',
          'biz.util.openLink'
        ] // 必填，需要使用的jsapi列表，注意：不要带dd。
      });
      dd.error(function (err) {
        // eslint-disable-next-line no-alert
        alert(`url:${url}, dd error: ${JSON.stringify(err)}`);
      });
    } else {
      // eslint-disable-next-line no-alert
      alert('res:' + JSON.stringify(res));
    }
  };
  getDDConfig();
}

if (window.YwkHybrid.os.android) {
  document.body.classList.add('android');
} else {
  document.body.classList.add('iOS');
}
if (window.YwkHybrid.os.ywk) {
  document.body.classList.add('YWK');
}
if ('addEventListener' in document) {
  document.addEventListener(
    'DOMContentLoaded',
    function () {
      if (window.YwkHybrid.os.ios) {
        FastClick.prototype.focus = function (targetElement) {
          // 处理ios输入框第二次点击不好聚焦问题
          var length;
          //兼容处理:在iOS7中，有一些元素（如date、datetime、month等）在setSelectionRange会出现TypeError
          //这是因为这些元素并没有selectionStart和selectionEnd的整型数字属性，所以一旦引用就会报错，因此排除这些属性才使用setSelectionRange方法
          if (
            window.YwkHybrid.os.ios &&
            targetElement.setSelectionRange &&
            targetElement.type.indexOf('date') !== 0 &&
            targetElement.type !== 'time' &&
            targetElement.type !== 'month' &&
            targetElement.type !== 'email' &&
            targetElement.type !== 'number'
          ) {
            length = targetElement.value.length;
            targetElement.setSelectionRange(length, length);
            /*修复bug ios 11.3不弹出键盘，这里加上聚焦代码，让其强制聚焦弹出键盘*/
            targetElement.focus();
          } else {
            targetElement.focus();
          }
        };
        FastClick.prototype.needsClickForParent = function (target) {
          let parent = target.parentNode;
          if (parent == null) {
            return false;
          }
          let b = /\bneedsclick\b/.test(parent.className);
          if (!b) {
            return this.needsClickForParent(parent);
          } else {
            return true;
          }
        };

        FastClick.prototype.needsClick = function (target) {
          if (this.needsClickForParent(target) === true) {
            return true;
          }
          switch (target.nodeName.toLowerCase()) {
            // Don't send a synthetic click to disabled inputs (issue #62)
            case 'button':
            case 'select':
            case 'textarea':
              if (target.disabled) {
                return true;
              }

              break;
            case 'input':
              // File inputs need real clicks on iOS 6 due to a browser bug (issue #68)
              if (target.type === 'file' || target.disabled) {
                return true;
              }

              break;
            case 'label':
            case 'iframe': // iOS8 homescreen apps can prevent events bubbling into frames
            case 'video':
              return true;
          }

          return /\bneedsclick\b/.test(target.className);
        };
        FastClick.attach(document.body);
      }
    },
    false
  );
}

// 注册EventEmitter全局事件
const EventEmitter = require('events');
window.eventEmitter = new EventEmitter();
window.eventEmitter.setMaxListeners(50);

setUtm();

ReactDOM.render(
  <Provider {...store}>
    <LocaleProvider
      locale={{
        Pagination: undefined,
        DatePicker: undefined,
        DatePickerView: undefined,
        InputItem: undefined
      }}
    >
      <Router />
    </LocaleProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
